import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';

import { Application } from '../../../shared/containers/Application';
import { IReduxStore } from '../../../shared/store';
import { IApplicationContext } from '../../../shared/types/applicationContext';

interface IDeps {
  store: IReduxStore;
  context: IApplicationContext;
}

export const renderApplication = ({ store, context }: IDeps) => {
  const projectName = context.config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  hydrateRoot(rootElement, <Application context={context} reduxStore={store} />);
};
